(function () {
  'use strict';

  angular.module('app').service('ProviderContactModalService', ProviderContactModalService);

  ProviderContactModalService.$inject = ['ModalService'];

  function ProviderContactModalService(ModalService) {
    const service = {
      openProviderContact: openProviderContact,
    };

    return service;

    function openProviderContact(item, provider, mode, fast, successCallback) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/providers/provider-contacts/modals/provider-contact-detail-modal.html',
        controller: ProviderContactDetailModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          provider: provider,
          mode: mode,
          fast: fast,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      ProviderContactDetailModalCtrl.$inject = [
        '$element',
        'item',
        'provider',
        'mode',
        'fast',
        'successCallback',
        'UtilService',
      ];
    }

    function ProviderContactDetailModalCtrl(
      $element,
      item,
      provider,
      mode,
      fast,
      successCallback,
      UtilService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.item = item;
      vm.provider = provider;
      vm.mode = mode;
      vm.fast = fast;

      vm.modalTitle = item.id ? 'CONTACT_DETAILS' : 'NEW_CONTACT';

      vm.onProviderContactSaved = onProviderContactSaved;
      vm.onProviderContactCanceled = onProviderContactCanceled;

      function onProviderContactSaved(data) {
        $element.modal('hide');
        successCallback(data);
      }

      function onProviderContactCanceled() {
        $element.modal('hide');
      }
    }
  }
})();
